import { requestPayment } from '@/shared/api/payment';
import { type Payment } from '@/shared/api/payment/types';
import { getPdTma } from '@/shared/stores/app-store/app-store';

import { Method } from '../types';
import { type Responder } from './respond-with-message';
import { validateMessageData } from './validate-message-data';
import { warnIncorrectValues } from './warn-incorrect-values';

export const requestPaymentHandler = async (value: Payment, respond: Responder) => {
  const { amount, description, externalId } = value;

  if (!validateMessageData({ value: externalId, allowedTypes: ['string'] })) {
    warnIncorrectValues(Method.REQUEST_PAYMENT, 'externalId', ['string']);
  }

  if (!validateMessageData({ value: amount, allowedTypes: ['number'] })) {
    warnIncorrectValues(Method.REQUEST_PAYMENT, 'amount', ['number']);
  }

  if (!validateMessageData({ value: description, allowedTypes: ['string'] })) {
    warnIncorrectValues(Method.REQUEST_PAYMENT, 'description', ['string']);
    return;
  }

  if (amount < 1) {
    warnIncorrectValues(Method.REQUEST_PAYMENT, 'amount', ['number'], 'amount>=1');
    return;
  }

  if (description?.length > 255) {
    warnIncorrectValues(
      Method.REQUEST_PAYMENT,
      'amount',
      ['string'],
      'description.length<=255'
    );
    return;
  }

  const data = await requestPayment(value, getPdTma());

  respond({ method: Method.REQUEST_PAYMENT, value: data });
};
